import { useEffect } from 'react';
import type { ResponsePayload } from '../../../types';
import { AdditionalResources } from '../../questions/AdditionalResources';
import { registerQuestionRenderer, type QuestionRendererComponent } from './registry';

const AdditionalResourcesRenderer: QuestionRendererComponent = ({
  question,
  existingResponse,
  onDraftChange,
  onHasUserInputChange,
  onValidityChange,
  onExtrasChange,
}) => {
  void onExtrasChange;
  const questionId = question?.id ?? existingResponse?.question ?? -1;

  useEffect(() => {
    if (questionId < 0) {
      onDraftChange(null);
    } else {
      const payload: ResponsePayload = {
        question: questionId,
      };
      onDraftChange(existingResponse ?? payload);
    }

    onHasUserInputChange?.(false);
    onValidityChange?.(true);
  }, [questionId, existingResponse, onDraftChange, onHasUserInputChange, onValidityChange]);

  return <AdditionalResources options={question?.options} />;
};

registerQuestionRenderer(['additional_resources'], AdditionalResourcesRenderer);
